import * as types from "@root/types";
import cx from "classnames";
import React, { FC } from "react";

interface ArtistCardProps {
  artist: types.Artist;
  includeName: boolean;
  classes?: string;
}

const ArtistCard: FC<ArtistCardProps> = ({ artist, includeName, classes }) => {
  if (!artist) {
    return null;
  }
  const label_id = `artist_name_${artist.id}`;
  const imageUrl =
    artist?.artPieces[0] && artist.artPieces[0].imageUrls?.medium;

  if (!imageUrl) {
    return null;
  }

  const title = artist.name || "";
  const link = `/artists/${artist.login}`;

  return (
    <div className={cx("artist-card", classes)}>
      <a className="artist-card--image" href={link} aria-labelledby={label_id}>
        <img loading="lazy" src={imageUrl} title={title} />
      </a>
      <div className="artist-card--details" hidden={!includeName}>
        <a className="artist-card--link" href={link} id={label_id}>
          {artist.name}
        </a>
      </div>
    </div>
  );
};

export { ArtistCard, ArtistCardProps };
